import type React from 'react';
import { styled, css } from 'styled-components';

export interface IButtonGroup {
  noWrap?: boolean;
  vertical?: boolean;
  align?: string;
  spacer?: string;
  children: React.ReactNode;
}

const VerticalContainer = styled.div`
  margin: -5px;
  > * {
    margin: 5px;
  }
`;

interface IButtonGroupWrapper {
  $styled: Pick<IButtonGroup, 'noWrap' | 'align' | 'vertical' | 'spacer'>;
}

const Wrapper = styled.div<IButtonGroupWrapper>`
  display: ${({ $styled: { align } }) => (align ? 'flex' : 'inline-flex')};
  flex-wrap: ${({ $styled: { noWrap } }) => !noWrap && 'wrap'};
  margin: ${({ $styled: { spacer, vertical } }) => !spacer && !vertical && '-5px'};
  justify-content: ${({ $styled: { align } }) => (align === 'right' ? 'flex-end' : align)};
  > * {
    margin: ${({ $styled: { vertical } }) => !vertical && '5px'};
  }
  ${({ $styled: { spacer, vertical } }) =>
    spacer === 'top' &&
    css`
      margin: ${() => (vertical ? '15px 0 0' : '10px -5px -5px')};
    `};
  ${({ $styled: { spacer, vertical } }) =>
    spacer === 'bottom' &&
    css`
      margin: ${() => (vertical ? '0 0 15px' : '-5px -5px 10px')};
    `};
`;

const ButtonGroup: React.FC<IButtonGroup> = ({ noWrap, vertical, align, spacer, children, ...other }) => (
  <Wrapper
    {...other}
    $styled={{
      noWrap,
      align,
      spacer,
      vertical,
    }}>
    {vertical ? <VerticalContainer>{children}</VerticalContainer> : children}
  </Wrapper>
);

export default ButtonGroup;
